import { Pipe, PipeTransform } from '@angular/core';
import { ActivatableItemSummary, ItemType } from '@vendasta/marketplace-apps';

@Pipe({ name: 'formatProductRequirement' })
export class FormatProductRequirementPipe implements PipeTransform {
  transform(item: ActivatableItemSummary): string {
    if (item?.requiredItems?.length > 0) {
      const requiredItemName = item.requiredItems[0].name;
      switch (item.itemType) {
        case ItemType.ITEM_TYPE_ADDON:
          return `Add-on to ${requiredItemName}`;
        case ItemType.ITEM_TYPE_APP:
          if (item.requiredItems.length > 1) {
            return `Requires ${requiredItemName} and ${item.requiredItems.length - 1} more`;
          }
          return `Requires ${requiredItemName}`;
        default:
          return '';
      }
    }
    return '';
  }
}
